import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import { StateCropSetting } from '../cropsetting.model';

@Injectable({
  providedIn: 'root',
})
export class CropSettingsService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/planet-proof/secure/cropsetting/';

  getCropSettings(): Observable<StateCropSetting[]> {
    return this.http.get<StateCropSetting[]>(this.baseUrl);
  }

  getCropSetting(cropId: number): Observable<StateCropSetting> {
    return this.http.get<StateCropSetting>(`${this.baseUrl}${cropId}`);
  }

  upsertCropSetting(cropSetting: StateCropSetting) {
    return this.http.post<StateCropSetting>(`${this.baseUrl}`, cropSetting);
  }

  deleteCropSetting(cropSetting: StateCropSetting) {
    return this.http.delete<StateCropSetting>(`${this.baseUrl}${cropSetting.id}`);
  }
}
